import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {WPContentSectionWithButtonAndSummary} from '../../typings/WPContentSectionWithButtonAndSummary';

@Component({
  selector: 'app-search-content-text-section',
  templateUrl: './search-content-text-section.component.html',
  styleUrl: './search-content-text-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block md:rounded-lg md:border md:border-grey-9 md:bg-white md:px-4 md:py-5',
  },
})
export class SearchContentTextSectionComponent {
  public section = input<WPContentSectionWithButtonAndSummary>(null);
}
